import React from "react";
import "./dashboard.scss";
import sections from "../../utils/dashboard-utils/dashboard-sections";
import alvaras from "../../images/icons/alvaras.png";
import arquivo from "../../images/icons/arquivo.png";
import dividaAtiva from "../../images/icons/divida-ativa.png";
import iss from "../../images/icons/iss.png";
import notaFiscal from "../../images/icons/nota-fiscal.png";
import relatorios from "../../images/icons/relatorios.png";

//let sectionsFirstHalf = sections.slice(0, 3);
//let sectionsLastHalf = sections.slice(3);

function returnIconForMap(iconName) {
  switch (iconName) {
    case "notaFiscal":
      return notaFiscal;
    case "iss":
      return iss;
    case "alvaras":
      return alvaras;
    case "relatorios":
      return relatorios;
    case "dividaAtiva":
      return dividaAtiva;
    case "arquivo":
      return arquivo;
    default:
      return null;
  }
}

export default ({ onSectionChanged, visible }) => {
  function sectionClicked(value, paths) {
    onSectionChanged({ sectionName: value, sectionPaths: paths });
  }

  return (
    <div style={{ display: visible ? "" : "none" }}>
      <div className={"dashboard-cards-div"}>
        {sections.map((section, index) => {
          return (
            <div
              onClick={() => sectionClicked(section.sectionName, section.paths)}
              key={index}
              className="dashboard-section-card"
            >
              <div>
                <img width={50} src={returnIconForMap(section.iconName)} />
              </div>
              <div className={"dashboard-section-card-name"}>
                {section.sectionName}
              </div>
              <div className={"dashboard-section-card-description"}>
                Palavras-chave: {section.description}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
